import React from 'react';
import { Route, Switch, Redirect, HashRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { CssBaseline } from './themes/default';
import { BackendLayout, LoginLayout } from './components/layouts';
import {
          Login,
          Dashboard,
          Logs,
          Users,
          UserCreate,
          UserUpdate,
          Pages,
          PageCreate,
          PageUpdate,
          Categories,
          CategoryCreate,
          Featureds,
          FeaturedCreate,
          FeaturedUpdate,
          Banners,
          BannersCreate,
          BannersUpdate,
          Blog, 
          BlogCreate, 
          BlogUpdate,
          PageContent,
          PageContentCreate,
          PageContentUpdate,
          Products,
          ProductCreate,
          ProductUpdate,
          Autogestion,
          AutogestionCreate,
          AutogestionUpdate,
          ClientsPayment,
          Alerts,
          AlertCreate,
          AlertUpdate,
          Polls,
          PollCreate,
          PollUpdate,
          PollBuilder,
          Report__Wheel,
          Data,
          PolicyFind,
          Test,
          Page404
        } from './pages';

import 'moment/locale/es';

moment.locale('es');

const App = (props) => {

  if(props.User !== null) {

    return (
      <React.Fragment>
        <CssBaseline />
        <MuiPickersUtilsProvider utils={ MomentUtils } locale={'es'}>
          <HashRouter>
            <Switch>
              <Route exact path="/">
                <Redirect to="/dashboard" />
              </Route>
              <BackendLayout path="/dashboard" component={ Dashboard } />

              <BackendLayout path="/logs" component={ Logs } />

              <BackendLayout exact path="/categories" component={ Categories } />
              <BackendLayout exact path="/categories/page/:page" component={ Categories } />
              <BackendLayout exact path="/categories/create" component={ CategoryCreate } />

              <BackendLayout exact path="/pages" component={ Pages } />
              <BackendLayout exact path="/pages/page/:page" component={ Pages } />
              <BackendLayout exact path="/pages/create" component={ PageCreate } />
              <BackendLayout exact path="/pages/update/:id" component={ PageUpdate } />

              <BackendLayout exact path="/featureds" component={ Featureds } />
              <BackendLayout exact path="/featureds/page/:page" component={ Featureds } />
              <BackendLayout exact path="/featureds/create" component={ FeaturedCreate } />
              <BackendLayout exact path="/featureds/update/:id" component={ FeaturedUpdate } />

              <BackendLayout exact path="/blog" component={ Blog } />
              <BackendLayout exact path="/blog/page/:page" component={ Blog } />
              <BackendLayout exact path="/blog/create" component={ BlogCreate } />
              <BackendLayout exact path="/blog/update/:id" component={ BlogUpdate } />

              <BackendLayout exact path="/page-content" component={ PageContent } />
              <BackendLayout exact path="/page-content/page/:page" component={ PageContent } />
              <BackendLayout exact path="/page-content/create" component={ PageContentCreate } />
              <BackendLayout exact path="/page-content/update/:id" component={ PageContentUpdate } />

              <BackendLayout exact path="/banners" component={ Banners } />
              <BackendLayout exact path="/banners/page/:page" component={ Banners } />
              <BackendLayout exact path="/banners/create" component={ BannersCreate } />
              <BackendLayout exact path="/banners/update/:id" component={ BannersUpdate } />

              <BackendLayout exact path="/users" component={ Users } />
              <BackendLayout exact path="/users/page/:page" component={ Users } />
              <BackendLayout exact path="/users/create" component={ UserCreate } />
              <BackendLayout exact path="/users/update/:id" component={ UserUpdate } />

              <BackendLayout exact path="/products" component={ Products } />
              <BackendLayout exact path="/products/create" component={ ProductCreate } />
              <BackendLayout exact path="/products/update/:id" component={ ProductUpdate } />

              <BackendLayout exact path="/autogestion" component={ Autogestion } />
              <BackendLayout exact path="/autogestion/page/:page" component={ Autogestion } />
              <BackendLayout exact path="/autogestion/create" component={ AutogestionCreate } />
              <BackendLayout exact path="/autogestion/update/:id" component={ AutogestionUpdate } />

              <BackendLayout exact path="/client-payment" component={ ClientsPayment } />
              <BackendLayout exact path="/client-payment/page/:page" component={ ClientsPayment } />

              <BackendLayout exact path="/alerts" component={ Alerts } />
              <BackendLayout exact path="/alerts/page/:page" component={ Alerts } />
              <BackendLayout exact path="/alerts/create" component={ AlertCreate } />
              <BackendLayout exact path="/alerts/update/:id" component={ AlertUpdate } />

              <BackendLayout exact path="/polls" component={ Polls } />
              <BackendLayout exact path="/polls/page/:page" component={ Polls } />
              <BackendLayout exact path="/polls/create" component={ PollCreate } />
              <BackendLayout exact path="/polls/update/:id" component={ PollUpdate } />
              <BackendLayout exact path="/polls/builder/:id" component={ PollBuilder } />

              <BackendLayout exact path="/data" component={ Data } />
              <BackendLayout exact path="/policy" component={ PolicyFind } />
              <BackendLayout exact path="/test" component={ Test } />

              <BackendLayout exact path="/reports/wheel" component={ Report__Wheel } />

              <BackendLayout exact path="/error" component={ Page404 } />

              <LoginLayout exact path="/login" component={ Login } />

              <Redirect to="/dashboard" />
            </Switch>
          </HashRouter>
        </MuiPickersUtilsProvider>
      </React.Fragment>
    );

  }else{

    return (
      <React.Fragment>
        <CssBaseline />
        <HashRouter>
          <Switch>
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>
            <LoginLayout path="/login" component={ Login } />
            <Redirect to="/login" />
          </Switch>
        </HashRouter>
      </React.Fragment>
    )

  }

}

const mapStateToProps = (state) => {
  return {
    User: state.User
  }
}

export default connect(mapStateToProps)(App);
